import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SEOHead
        title="页面未找到"
        description="您访问的页面不存在，请检查链接是否正确。"
      />
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-6">
          <div className="text-8xl md:text-9xl font-heading font-black text-background-200 select-none mb-4">
            404
          </div>
          <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-2">
            页面未找到
          </h1>
          <p className="text-foreground-500 text-sm mb-2 font-mono">
            {location.pathname}
          </p>
          <p className="text-foreground-400 text-sm mb-8">
            您访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex px-6 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}